import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import Quote from '../../../components/Quote';
import props from '../../../lib/contentLayoutProps/the-kingston-difference/layoutProps';

import eliza from './eliza@large.jpg';

import styles from './index.module.scss';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="head-principal-welcome">
    <h1>Head Principal Welcome</h1>
    <div className={styles.wrapper}>
      <div className={styles.text}>
        <Quote styles={{ marginTop: '16px' }}>
          <p>
            On behalf of KCC/KIK/KIS, I invite you to explore our website and get to know a little bit about our very
            unique and exclusively significant school. We hope that you enjoy your virtual visit and will consider
            coming to visit us in person in the near future.
          </p>
        </Quote>
        <p>
          Kingston is comprised of Playgroup, Nursery, Kindergarten and Primary students who are guided by a diverse and
          uniquely qualified staff united in our belief bilingualism and a small-school approach to learning. After
          graduating from Kingston Primary, our students have the through-train option of continuing the small-school
          approach in secondary school at International College Hong Kong.
        </p>
        <p>
          Since 1994, Kingston has dedicated itself to the worthy pursuit of equipping students to be proficient in two
          of the most significant languages of the twenty-first century: English and Chinese (Putonghua). For over 20
          years, Kingston has successfully provided a challenging and stimulating environment that nurtures the balanced
          development of students who, in their own unique way, grow into active and responsible world citizens.
        </p>
        <p>
          We are proud to have been the first school in Hong Kong to be authorized to provide the International
          Baccalaureate Primary Years Programme. The IBPYP provides a unique framework for approaches to learning. The
          flexibility of the IBO framework has ensured that Kingston has been able to maintain its dedication to
          bilingualism while ensuring international standards of English, Mathematics, Social Sciences, Science, Arts
          and Physical Education and providing an excellent environment for Chinese language development.
        </p>
        <p>
          Members of the community who take the opportunity to walk the halls and visit the classrooms of Kingston often
          comment on the fluidity with which our students switch between Putonghua and English. This is a point of
          particular pride for us. While many schools view languages as subjects, we take particular pride in having two
          living languages at Kingston.
        </p>
        <p>
          Kingston teachers come from all over the globe and they bring with them a wide variety of experiences. Varied
          experiences and points of view are valued within the IB approaches to learning, as is lifelong learning. Our
          dedication to teacher professional development is unsurpassed and makes Kingston an attractive option for
          teachers who want to work at a school where training and experience results in a mature programme with a deep
          understanding of the IBPYP framework and the most innovative, successful, child-centred educational programme
          ever developed.
        </p>
        <p>
          We hope you will come and visit us soon. Please be sure to join one of our upcoming tours so that you might
          meet our exceptional students and staff and experience the warmth of our cozy environment!
        </p>
      </div>
      <div className={styles.image}>
        <img src={eliza} alt="Eliza Wong, Head Principal" />
        <div className={styles.caption}>Eliza Wong, Head Principal</div>
      </div>
    </div>
  </ContentLayout>
);
